import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
    mode: 'history', // 去掉URL中的#，生产环境需后端配合
    base: process.env.BASE_URL,
    routes: [
        // 首页
        {
            path: '/',
            name: 'Home',
            component: () => import('@/pages/Home.vue')
        },
        // 登录页
        {
            path: '/login',
            name: 'Login',
            component: () => import('@/pages/Login.vue')
        },
        // 注册页
        {
            path: '/register',
            name: 'Register',
            component: () => import('@/pages/Register.vue')
        },
        // 信息列表页（支持分类参数）
        {
            path: '/info/list',
            name: 'InfoList',
            component: () => import('@/pages/InfoList.vue')
        },
        {
            path: '/info/list/:category',
            name: 'InfoListByCategory',
            component: () => import('@/pages/InfoList.vue')
        },
        // 信息详情页
        {
            path: '/info/detail/:id',
            name: 'InfoDetail',
            component: () => import('@/pages/InfoDetail.vue')
        },
        // 发布信息页
        {
            path: '/publish',
            name: 'Publish',
            component: () => import('@/pages/Publish.vue')
        },
        // 会员中心（嵌套路由）
        {
            path: '/member',
            name: 'Member',
            component: () => import('@/pages/Member/Index.vue'),
            children: [
                // 信息管理
                {
                    path: 'info-manage',
                    name: 'InfoManage',
                    component: () => import('@/pages/Member/InfoManage.vue')
                },
                // 认证中心
                {
                    path: 'auth-center',
                    name: 'AuthCenter',
                    component: () => import('@/pages/Member/AuthCenter.vue')
                },
                // 默认显示信息管理
                {
                    path: '',
                    redirect: 'info-manage'
                }
            ]
        },
        // 法律相关页面
        {
            path: '/agreement',
            name: 'Agreement',
            component: () => import('@/pages/Agreement.vue')
        },
        {
            path: '/privacy',
            name: 'Privacy',
            component: () => import('@/pages/Privacy.vue')
        },
        // 404页面（放在最后）
        {
            path: '*',
            name: 'NotFound',
            component: () => import('@/pages/NotFound.vue')
        }
    ],
    // 路由跳转后滚动到顶部
    scrollBehavior(to, from, savedPosition) {
        if (savedPosition) {
            return savedPosition
        } else {
            return {x: 0, y: 0}
        }
    }
})
